
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useToast } from "../../contexts/ToastContext";
import leaveService from "../../services/leaveService";
import { getErrorMessage } from "../../utils/errorHandler";
import FormCard from "../../components/ui/FormCard";
import FormSection from "../../components/ui/FormSection";
import FormActions from "../../components/ui/FormActions";
import Breadcrumb from "../../components/ui/Breadcrumb";
import "../../styles/FormCard.css";

const CalendarEventEdit = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const toast = useToast();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  // ============================================================
  // RETOUR VERS LA PAGE PRè‰Cè‰DENTE
  // ============================================================

  const fromLocation =
    location.state?.from || "/rh/calendar";

  // ============================================================
  // FORM DATA
  // Correspond aux attributs de Holiday
  // ============================================================

  const [formData, setFormData] = useState({
    name: "",
    date: "",
    holiday_type: "NATIONAL",
    description: "",
    year: "",
    duration_days: 1,
    is_active: true,
    is_religious: false,
    is_recurring: false,
    color: "#3b82f6",
  });

  const [errors, setErrors] = useState({});

  // ============================================================
  // CHARGER LE JOUR Fè‰RIè‰
  // ============================================================

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    try {
      setLoading(true);

      console.log(
        "[CalendarEventEdit] Chargement du jour férié ID :",
        id
      );

      const response =
        await leaveService.getHolidayById(id);

      const holiday =
        response?.data || response;

      console.log(
        "[CalendarEventEdit] Jour férié chargé :",
        holiday
      );

      // ========================================================
      // REMPLIR LE FORMULAIRE
      // ========================================================

      setFormData({
        name:
          holiday.name || "",

        date:
          holiday.date || "",

        holiday_type:
          holiday.holiday_type || "NATIONAL",

        description:
          holiday.description || "",

        year:
          holiday.year ||
          (
            holiday.date
              ? new Date(holiday.date).getFullYear()
              : ""
          ),

        duration_days:
          holiday.duration_days || 1,

        is_active:
          holiday.is_active !== undefined
            ? holiday.is_active
            : true,

        is_religious:
          holiday.is_religious !== undefined
            ? holiday.is_religious
            : false,

        is_recurring:
          holiday.is_recurring !== undefined
            ? holiday.is_recurring
            : false,

        // ======================================================
        // COULEUR
        // Si aucune couleur en base â†’ bleu par défaut
        // ======================================================

        color:
          holiday.color || "#3b82f6",
      });

    } catch (err) {
      console.error(
        "[CalendarEventEdit] Erreur chargement jour férié :",
        err
      );

      toast.error(
        getErrorMessage(err)
      );

    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // MODIFICATION DES CHAMPS
  // ============================================================

  const handleChange = (e) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;

    setFormData((prev) => ({
      ...prev,

      [name]:
        type === "checkbox"
          ? checked

          : name === "duration_days" ||
            name === "year"
          ? value === ""
            ? ""
            : Number(value)

          : value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // ============================================================
  // VALIDATION
  // ============================================================

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name =
        "Le nom du jour férié est requis";
    }

    if (!formData.date) {
      newErrors.date =
        "La date est requise";
    }

    if (
      !formData.duration_days ||
      Number(formData.duration_days) < 1
    ) {
      newErrors.duration_days =
        "La durée doit èªtre au minimum de 1 jour";
    }

    // Vérification de la couleur
    if (
      !formData.color ||
      !/^#[0-9A-Fa-f]{6}$/.test(formData.color)
    ) {
      newErrors.color =
        "La couleur doit èªtre au format #RRGGBB";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ============================================================
  // ENREGISTRER LES MODIFICATIONS
  // ============================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      setSubmitting(true);

      // ========================================================
      // DONNè‰ES ENVOYè‰ES è€ L'API
      // ========================================================

      const holidayData = {
        name:
          formData.name.trim(),

        date:
          formData.date,

        holiday_type:
          formData.holiday_type,

        description:
          formData.description.trim() || null,

        year:
          formData.year
            ? Number(formData.year)
            : new Date(
                formData.date
              ).getFullYear(),

        duration_days:
          Number(formData.duration_days),

        is_active:
          Boolean(formData.is_active),

        is_religious:
          Boolean(formData.is_religious),

        is_recurring:
          Boolean(formData.is_recurring),

        // ======================================================
        // COULEUR
        // ======================================================

        color:
          formData.color || "#3b82f6",
      };

      console.log(
        "[CalendarEventEdit] Modification du jour férié :",
        holidayData
      );

      // ========================================================
      // UPDATE TABLE holidays
      // ========================================================

      await leaveService.updateHoliday(
        id,
        holidayData
      );

      toast.success(
        "Jour férié modifié avec succès"
      );

      // Retour vers le calendrier
      navigate(fromLocation);

    } catch (err) {
      console.error(
        "[CalendarEventEdit] Erreur modification jour férié :",
        err
      );

      toast.error(
        getErrorMessage(err)
      );

    } finally {
      setSubmitting(false);
    }
  };

  // ============================================================
  // ANNULER
  // ============================================================

  const handleCancel = () => {
    navigate(fromLocation);
  };

  // ============================================================
  // CHARGEMENT
  // ============================================================

  if (loading) {
    return (
      <div className="loading-state">
        <div className="spinner"></div>

        <p>
          Chargement...
        </p>
      </div>
    );
  }

  // ============================================================
  // BREADCRUMB
  // ============================================================

  const breadcrumbItems = [
    {
      label: "RH",
      to: "/rh/dashboard",
    },

    {
      label: "Calendrier",
      to: "/rh/calendar",
    },

    {
      label: "Modifier un jour férié",
    },
  ];

  // ============================================================
  // INTERFACE
  // ============================================================

  return (
    <div
      style={{
        padding: "24px",
      }}
    >

      <Breadcrumb
        items={breadcrumbItems}
      />

      <FormCard
        title="Modifier un jour férié"
        showBackButton
        onBack={handleCancel}
      >

        <form
          onSubmit={handleSubmit}
        >

          {/* ==================================================
              INFORMATIONS DU JOUR Fè‰RIè‰
          ================================================== */}

 `
<FormSection title="Affichage">
  <div className="form-group">
    <label htmlFor="color">
      Couleur du jour férié
    </label>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginTop: "8px",
      }}
    >
      <input
        id="color"
        type="color"
        name="color"
        value={formData.color || "#3b82f6"}
        onChange={handleChange}
        style={{
          width: "100px",
          height: "40px",
          padding: "2px",
          cursor: "pointer",
        }}
      />

      <input
        type="text"
        name="color"
        value={formData.color || "#3b82f6"}
        onChange={handleChange}
        placeholder="#3b82f6"
        maxLength={7}
        style={{
          width: "110px",
        }}
      />

      <div
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "6px",
          backgroundColor: formData.color || "#3b82f6",
          border: "1px solid #ccc",
        }}
      />
    </div>

    {errors.color && (
      <span className="error">
        {errors.color}
      </span>
    )}

    <small
      style={{
        display: "block",
        marginTop: "6px",
        color: "#666",
      }}
    >
      Cette couleur sera utilisée pour afficher le jour férié
      dans le calendrier.
    </small>
  </div>
</FormSection>




          {/* ==================================================
              DATE ET DURè‰E
          ================================================== */}

          <FormSection
            title="Date et durée"
          >

            {/* DATE */}

            <div className="form-group">

              <label>
                Date *
              </label>

              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                className={
                  errors.date
                    ? "error"
                    : ""
                }
              />

              {errors.date && (
                <span className="error">
                  {errors.date}
                </span>
              )}

            </div>


            {/* ANNè‰E */}

            <div className="form-group">

              <label>
                Année
              </label>

              <input
                type="number"
                name="year"
                value={formData.year}
                onChange={handleChange}
                min="2000"
                max="2100"
                placeholder="Ex : 2026"
              />

            </div>


            {/* DURè‰E */}

            <div className="form-group">

              <label>
                Durée (jours) *
              </label>

              <input
                type="number"
                name="duration_days"
                value={
                  formData.duration_days
                }
                onChange={handleChange}
                min="1"
                className={
                  errors.duration_days
                    ? "error"
                    : ""
                }
              />

              {errors.duration_days && (
                <span className="error">
                  {
                    errors.duration_days
                  }
                </span>
              )}

            </div>

          </FormSection>


          {/* ==================================================
              AFFICHAGE / COULEUR
          ================================================== */}

          <FormSection
            title="Affichage"
          >

            <div className="form-group">

              <label>
                Couleur du jour férié
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginTop: "8px",
                }}
              >

                {/* COLOR PICKER */}

                <input
                  type="color"
                  name="color"
                  value={
                    formData.color
                  }
                  onChange={handleChange}
                  style={{
                    width: "100px",
                    height: "40px",
                    padding: "2px",
                    cursor: "pointer",
                  }}
                />

                {/* VALEUR HEXADè‰CIMALE */}

                <input
                  type="text"
                  value={
                    formData.color
                  }
                  onChange={(e) => {
                    const value =
                      e.target.value;

                    setFormData(
                      (prev) => ({
                        ...prev,
                        color: value,
                      })
                    );

                    if (errors.color) {
                      setErrors(
                        (prev) => ({
                          ...prev,
                          color: "",
                        })
                      );
                    }
                  }}
                  placeholder="#3b82f6"
                  maxLength={7}
                  style={{
                    width: "110px",
                  }}
                />

                {/* APERè‡U */}

                <div
                  title={
                    formData.color
                  }
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "6px",
                    backgroundColor:
                      formData.color ||
                      "#3b82f6",
                    border:
                      "1px solid #ccc",
                  }}
                />

              </div>

              {errors.color && (
                <span className="error">
                  {errors.color}
                </span>
              )}

              <small
                style={{
                  display: "block",
                  marginTop: "6px",
                  color: "#666",
                }}
              >
                Cette couleur sera utilisée
                pour afficher le jour férié
                dans le calendrier.
              </small>

            </div>

          </FormSection>


          {/* ==================================================
              OPTIONS
          ================================================== */}

          <FormSection
            title="Options"
          >

            {/* ACTIF */}

            <div className="form-group">

              <label>

                <input
                  type="checkbox"
                  name="is_active"
                  checked={
                    formData.is_active
                  }
                  onChange={handleChange}
                />

                {" "}
                Jour férié actif

              </label>

            </div>


            {/* RELIGIEUX */}

            <div className="form-group">

              <label>

                <input
                  type="checkbox"
                  name="is_religious"
                  checked={
                    formData.is_religious
                  }
                  onChange={handleChange}
                />

                {" "}
                Jour férié religieux

              </label>

            </div>


            {/* Rè‰CURRENT */}

            <div className="form-group">

              <label>

                <input
                  type="checkbox"
                  name="is_recurring"
                  checked={
                    formData.is_recurring
                  }
                  onChange={handleChange}
                />

                {" "}
                Jour férié récurrent

              </label>

            </div>

          </FormSection>


          {/* ==================================================
              ACTIONS
          ================================================== */}

          <FormActions
            onCancel={handleCancel}
            onSave={handleSubmit}
            saveText="Enregistrer les modifications"
            isLoading={submitting}
          />

        </form>

      </FormCard>

    </div>
  );
};

export default CalendarEventEdit;

